import { Box } from "@mui/material";

export function SponsorsBanner() {
  return (
    <Box
      style={{
        width: "320px",
        height: "56px",
        background: "#242436",
        borderBottom: "1px solid #f5f5f5",
        borderRadius: "0 0 16px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 auto",
      }}
    >
      <Box
        component="img"
        height={24}
        src="/sponsors.png"
        alt="Made with refine x Supabase x MUI"
      />
    </Box>
  );
}
